import React, { useState } from 'react';
import styled from 'styled-components';
import AuthModal from '../modals/AuthModal';

const HeaderContainer = styled.header`
  background: rgba(248, 250, 252, 0.94);
  border-bottom: 1px solid rgba(148, 163, 184, 0.18);
  padding: 0.9rem 0;
  position: sticky;
  top: 0;
  z-index: 1000;
  backdrop-filter: blur(16px);
`;

const HeaderContent = styled.div`
  max-width: 1160px;
  margin: 0 auto;
  padding: 0 1.6rem;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 768px) {
    padding: 0 1.2rem;
  }
`;

const Logo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.7rem;
  font-family:
    'Georgia',
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    serif;
  font-size: 1.35rem;
  font-weight: 700;
  color: #0f172a;
  text-decoration: none;
  letter-spacing: -0.03em;
`;

const Navigation = styled.nav`
  display: flex;
  align-items: center;
  gap: 1.4rem;

  @media (max-width: 768px) {
    gap: 1rem;
  }
`;

const NavLinks = styled.div`
  display: flex;
  align-items: center;
  gap: 1.15rem;

  @media (max-width: 640px) {
    display: none;
  }
`;

const NavLink = styled.a`
  color: #475569;
  text-decoration: none;
  font-weight: 600;
  font-size: 0.92rem;
  transition: color 0.2s ease;

  &:hover {
    color: #0f172a;
  }
`;

const StartTradingButton = styled.button`
  background: #0f172a;
  color: white;
  border: none;
  padding: 0.75rem 1.2rem;
  border-radius: 999px;
  font-weight: 700;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s ease;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;

  &:hover {
    background: #111827;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
`;

const Header = () => {
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);

  return (
    <HeaderContainer>
      <HeaderContent>
        <Logo>agent.market</Logo>
        <Navigation>
          <NavLinks>
            <NavLink href="#request-types">Request types</NavLink>
            <NavLink href="#request-template">Templates</NavLink>
            <NavLink href="#settlement">Settlement</NavLink>
            <NavLink href="#policy-controls">Policies</NavLink>
            <NavLink
              href="https://api.agent.market/redoc"
              target="_blank"
              rel="noopener noreferrer"
            >
              Docs ↗
            </NavLink>
            <NavLink href="mailto:support@agent.market">Support</NavLink>
          </NavLinks>
          <StartTradingButton onClick={() => setIsAuthModalOpen(true)}>
            Submit your agent
          </StartTradingButton>
        </Navigation>
      </HeaderContent>

      <AuthModal isOpen={isAuthModalOpen} onRequestClose={() => setIsAuthModalOpen(false)} />
    </HeaderContainer>
  );
};

export default Header;
